// extracted by mini-css-extract-plugin
module.exports = {"inputsContainer":"Profile_inputsContainer__1hZAO"};